"use client"

import styled from "@emotion/styled"
import { usePathname } from "next/navigation"
import { BlockRenderer, Container, CustomBreadcrumbs } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import FactoriesMap from "./FactoriesMap"
import MapContentText from "./MapContentText"

const StyledTopDiv = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 98px;
  }
`

type Props = {
  locale: string
  data: any
  companyId?: number
  hideBreadCrumbs?: boolean
  companyName?: string
  messages?: { learnMore: string; followUs: string; learnMoreAbout: string }
}

const FactoryMapPage: React.FC<Props> = ({ data, locale, hideBreadCrumbs = false }: Props) => {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const pathname = usePathname()
  const components = {
    contentText: MapContentText,
    factoryMap: FactoriesMap,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []

  return (
    <>
      {!hideBreadCrumbs ? (
        <Container>
          <CustomBreadcrumbs current={selfObject} parents={parents} />
        </Container>
      ) : (
        <StyledTopDiv></StyledTopDiv>
      )}
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            noTransition: true,
            linkColor: "#2768A3",
            noBackground: true,
            pathname,
            notCentered: true,
          }
        } else {
          additionalProps = {
            locale,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}
export default FactoryMapPage
